<template>
    <b-modal size="lg" ref="createNewItemModal" hide-footer :title="$t('scdda_admin.editsector.header')">
        <b-container>
            <b-row>
                <b-col>
                    <b-form-group :label="$t('scdda_admin.editsector.nace')" label-for="sector_code_nace">
                        <b-form-input id="sector_code_nace" type="text" :state="!$v.currentItem.sector_code_nace.$error ? null : false" v-model="currentItem.sector_code_nace" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group :label="$t('scdda_admin.editsector.name_de')" label-for="sector_name_de">
                        <b-form-input id="sector_name_de" type="text" v-model="currentItem.sector_name_de" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group :label="$t('scdda_admin.editsector.name_en')" label-for="sector_name_en">
                        <b-form-input id="sector_name_en" type="text" v-model="currentItem.sector_name_en" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
        <b-button class="button-margin mt-3" variant="primary" block @click="createItem">{{ $t("scdda_admin.editsector.save") }}</b-button>
    </b-modal>
</template>
    <script>
    import SectorService from '../../../../../services/Riskmanagement/SectorService';
    import { helpers, required } from 'vuelidate/lib/validators';
    export default {
        name: 'sector-modal',
        props: ['savedCallback'],
        data() {
            return {
                currentItemEditMode: false,
                currentItem: {}
            }
        },
        validations: {
            currentItem: {
                sector_code_nace:   {required},
                sector_name_de:     {required},
                sector_name_en:     {required},
            }
        },
        methods: {
            enterEditMode() {
                this.currentItemEditMode = true;
            },
            leaveEditMode() {
                this.currentItemEditMode = false;
            },
            showModal() {
                this.$v.$reset();
                this.currentItemEditMode = false;
                this.$refs.createNewItemModal.show();
            },
            hideModal() {
                this.$refs.createNewItemModal.hide();
                this.currentItem = {};
                this.$v.$reset();
            },
            setItem(Item) {
                this.currentItem = Item;
            },
            createItem() {
                this.$v.$touch();

                if(this.$v.$error) {
                    return;
                }

                this.$store.commit('loading/setLoading', true);

                if(!this.currentItemEditMode) {
                    SectorService.create(this.currentItem)
                        .then(response => {
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.editsector.success_title"),
                                type: 'success',
                                text: this.$t("scdda_admin.editsector.success_message")
                            });

                            this.$store.commit('loading/setLoading', false);

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.editsector.error_title"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }else {
                    SectorService.update(this.currentItem.id, this.currentItem)
                        .then(response => {
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.editsector.success_title"),
                                type: 'success',
                                text: this.$t("scdda_admin.editsector.success_message")
                                });

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("scdda_admin.editsector.error_title"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }
            }
        }
    }
    </script>
